import EventSubProcessPalette from './EventSubProcessPalette';

export default {
  __init__: [ 'eventSubProcessPalette' ],
  eventSubProcessPalette: [ 'type', EventSubProcessPalette ]
};
